import { render } from "./Ambient.vue?vue&type=template&id=ec8d3a78&scoped=true"
import script from "./Ambient.vue?vue&type=script&lang=js"
export * from "./Ambient.vue?vue&type=script&lang=js"

import "./Ambient.vue?vue&type=style&index=0&id=ec8d3a78&scoped=true&lang=css"

import exportComponent from "C:\\MyTools\\withokx\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8d3a78"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QInput,QBtn,QSpace,QSeparator,QScrollArea,QCardSection,QBtnGroup,QBtnToggle});
